/* jshint esversion: 6 */
import { filter, mergeMap } from 'rxjs/operators';
import api from 'app/redux/api.js';
import {
    ConnectionActions
} from 'app/redux/actions.js';
import * as constants from 'app/redux/constants.js';


export const fetchConnectionsEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.CONNECTION_LIST && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, null, ConnectionActions.receiveConnections))
);

export const fetchConnectionEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.CONNECTION_SHOW && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, ConnectionActions.receiveConnection))
);

export const createConnectionEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.CONNECTION_CREATE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, ConnectionActions.createdConnection))
);

export const updateConnectionEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.CONNECTION_UPDATE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, ConnectionActions.updatedConnection))
);

export const deleteConnectionEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.CONNECTION_DELETE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, ConnectionActions.deletedConnection))
);
